import React from 'react'

import {
  type WebViewBridgeContextMethodsHandlers,
  WebViewBridgeProvider,
} from '@fourthwall/webview-bridge'

type WebViewProviderProps = {
  children: React.ReactNode
}

type OpenMobilePageParameters = { mobile_path: string; url: string }

type CreatorDashboardWebViewHandlers = {
  openMobilePage: (params: OpenMobilePageParameters) => Promise<void>
  showInfoBanner: (message: string) => Promise<void>
  orderSampleForProduct: (data: { variantId: string; quantity: number }) => Promise<void>
}

export const WebViewProvider = ({ children }: WebViewProviderProps) => {
  const handlers: WebViewBridgeContextMethodsHandlers<CreatorDashboardWebViewHandlers> = {
    ios: {
      async openMobilePage(params: OpenMobilePageParameters) {
        window.webkit.messageHandlers.openMobilePage.postMessage(params)
      },
      async showInfoBanner(message: string) {
        window.webkit.messageHandlers.showInfoBanner.postMessage(message)
      },
      async orderSampleForProduct(data: { variantId: string; quantity: number }) {
        window.webkit.messageHandlers.orderSampleForProduct.postMessage(data)
      },
    },
    android: {
      async openMobilePage(params: OpenMobilePageParameters) {
        const stringifiedParams = JSON.stringify(params)

        window.CreatorDashboardHandler.openMobilePage(stringifiedParams)
      },
      async showInfoBanner(message) {
        window.CreatorDashboardHandler.showInfoBanner(message)
      },
      async orderSampleForProduct(data: { variantId: string; quantity: number }) {
        window.CreatorDashboardHandler.orderSampleForProduct(JSON.stringify(data))
      },
    },
  }

  return (
    <WebViewBridgeProvider userAgent={window.navigator.userAgent} handlers={handlers}>
      {children}
    </WebViewBridgeProvider>
  )
}
